<template>
  <a
    class="rounded-button"
    v-bind:class="{ 'rounded-button-red': danger }"
    v-on:click="$emit('handleClick')"
  >
    <div class="rounded-button--content">
      <slot/>

      <span
        v-if="title !== ''"
        class="rounded-button--content--title"
      >
        {{ title }}
      </span>
    </div>    
  </a>
</template>

<script>
  import AddIcon from '../../icons/add.vue'

  export default {
    name: 'RoundedButton',
    components: {
      AddIcon,
    },
    props: [
      'title',
      'to',
      'danger'
    ]
  }
</script>

<style lang="scss">
  .rounded-button {
    height: 30px;
    border-radius: 15px;
    padding: 0 15px;
    background-color: var(--blue);
    display: inline-block;
    transition: 0.2s;

    &--content {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      svg,
      &--title {
        display: inline-block;
      }

      svg {
        path {
          fill: var(--white);
        }
      }

      &--title {
        color: var(--white) !important;
        margin-right: 0 !important;
      }
    }
    
    &:hover {
      opacity: 0.8;
    }
  }

  .rounded-button-red {
    background-color: var(--red);
    width: 30px;
    padding: 0;
  } 
</style>